/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { Locale } from '../locale/Locale';
import { LocaleKeys } from '../locale/LocaleKeys';
import { AppError } from './AppError';

export class EmptyResponseError extends AppError {
    TAG: string = 'EmptyResponseError';

    protected title: string = Locale.getString(LocaleKeys.TEMPORARY_SERVICE_CONNECTION_ISSUE_TITLE);

    protected description: string;

    protected type: string = 'EmptyResponseError';

    constructor(code: string, message: string, description: string, title?: string) {
        super(code, message);
        this.code = code;
        this.message = message;
        this.description = description;
        if (title) this.title = title;
    }

    public getDescription(): string {
        return this.description;
    }

    public getTitle(): string {
        return this.title;
    }

    public getType(): string {
        return this.type;
    }
}
